import { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from '@mui/material';

import { buttonName, dialogTitleLabel } from '../../const/commonConst';
import { alertDialog, okButton } from '../../const/componentSize';
import { DialogType } from '../../type/DialogType';

import theme from '../../../theme';

type PropsType = {
	dialog: DialogType;
	onClose: () => void;
};

/**
 * アラートダイアログ
 */
export const AlertDialog = (props: PropsType) => {
	const { dialog, onClose } = props;

	const [titleColor, setTitleColor] = useState('');

	useEffect(() => {
		if (dialog.title === dialogTitleLabel.warning) {
			setTitleColor(theme.palette.warning.main);
		} else {
			setTitleColor(theme.palette.error.main);
		}
	}, [dialog.title]);

	return (
		<Dialog open={dialog.isOpened} sx={{ zIndex: theme.zIndex.dialog }}>
			<DialogTitle id="dialogTitle" sx={{ color: titleColor, fontWeight: 'bold' }}>
				{dialog.title}
			</DialogTitle>
			<DialogContent>
				<DialogContentText id="dialogContentText" sx={{ width: alertDialog.width, color: theme.palette.common.black, whiteSpace: 'pre-wrap' }}>
					{dialog.text}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button id="dialogButton" variant="contained" onClick={onClose} sx={{ width: okButton.width }}>
					<Typography sx={{ fontSize: 15, color: theme.palette.common.white }}>{buttonName.ok}</Typography>
				</Button>
			</DialogActions>
		</Dialog>
	);
};
